import React from 'react';

interface PillProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
  tone?: 'neutral' | 'accent' | 'spark' | 'partner' | 'success' | 'warning' | 'danger' | 'info';
  size?: 'sm' | 'md';
}

const toneMap: Record<NonNullable<PillProps['tone']>, { bg: string; fg: string; border: string }> = {
  neutral: { bg: '#fff', fg: 'var(--fg-2)', border: 'var(--border-2)' },
  accent:  { bg: 'var(--accent-soft)', fg: 'var(--accent-soft-fg)', border: 'transparent' },
  spark:   { bg: 'var(--accent-2-soft)', fg: 'var(--accent-2-soft-fg)', border: 'transparent' },
  partner: { bg: 'var(--partner-soft)', fg: 'var(--partner)', border: 'transparent' },
  success: { bg: 'var(--success-soft)', fg: 'var(--success)', border: 'transparent' },
  warning: { bg: 'var(--warning-soft)', fg: 'var(--warning)', border: 'transparent' },
  danger:  { bg: 'var(--danger-soft)', fg: 'var(--danger)', border: 'transparent' },
  info:    { bg: 'var(--info-soft)', fg: 'var(--info)', border: 'transparent' },
};

const Pill: React.FC<PillProps> = ({
  tone = 'neutral',
  active,
  size = 'sm',
  style,
  children,
  ...rest
}) => {
  const p = toneMap[tone];
  const isInteractive = !!rest.onClick || rest.type === 'submit';
  const base: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    padding: size === 'sm' ? '5px 12px' : '7px 14px',
    borderRadius: 'var(--radius-pill)',
    fontSize: size === 'sm' ? 12 : 13,
    fontWeight: 500,
    background: active ? 'var(--accent)' : p.bg,
    color: active ? '#fff' : p.fg,
    border: `1px solid ${active ? 'var(--accent)' : p.border}`,
    cursor: isInteractive ? 'pointer' : 'default',
    fontFamily: 'var(--font-sans)',
    whiteSpace: 'nowrap',
    transition: 'background 160ms var(--ease-standard), color 160ms var(--ease-standard), border-color 160ms var(--ease-standard)',
    ...style,
  };
  return (
    <button type="button" style={base} {...rest}>
      {children}
    </button>
  );
};

export default Pill;
